module.exports = __webpack_public_path__ + "static/media/multi-image-1-mobile.ea4cb229.png";